export const opinionsAttitude = {
  164734: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'AU',
  },
  164716: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'EU',
  },
  164728: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'BR',
  },
  164732: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'BR',
  },
  164727: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'BR',
  },
  164725: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'CA',
  },
  164652: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '100',
      counteract_share: '0',
      attitude: 'cooperate',
    },
    country_code: 'CN',
  },
  164647: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '100',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'attack',
    },
    country_code: 'CN',
  },
  164649: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'CN',
  },
  164645: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '100',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'attack',
    },
    country_code: 'CN',
  },
  164648: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '100',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'attack',
    },
    country_code: 'CN',
  },
  164654: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'CN',
  },
  164664: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'RU',
  },
  164711: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'LY',
  },
  164710: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'LY',
  },
  164653: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'CN',
  },
  164713: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'LY',
  },
  164646: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '100',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'attack',
    },
    country_code: 'CN',
  },
  164712: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'LY',
  },
  164651: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'CN',
  },
  164719: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '100',
      counteract_share: '0',
      attitude: 'cooperate',
    },
    country_code: 'EU',
  },
  164666: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'DE',
  },
  164717: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'EU',
  },
  164662: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'RU',
  },
  164663: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'RU',
  },
  164720: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'EU',
  },
  164721: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'EU',
  },
  164723: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '100',
      counteract_share: '0',
      attitude: 'cooperate',
    },
    country_code: 'EU',
  },
  164722: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'EU',
  },
  164714: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'EU',
  },
  164677: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '100',
      counteract_share: '0',
      attitude: 'cooperate',
    },
    country_code: 'FR',
  },
  164726: {
    attitude_balance: {
      negotiate_share: '#DIV/0!',
      attack_share: '#DIV/0!',
      cooperate_share: '#DIV/0!',
      counteract_share: '#DIV/0!',
      attitude: 'cooperate',
    },
    country_code: 'MX',
  },
  164724: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'IN',
  },
  164735: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'ID',
  },
  164682: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '100',
      counteract_share: '0',
      attitude: 'cooperate',
    },
    country_code: 'KZ',
  },
  164731: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '100',
      counteract_share: '0',
      attitude: 'cooperate',
    },
    country_code: 'BR',
  },
  164729: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '100',
      counteract_share: '0',
      attitude: 'cooperate',
    },
    country_code: 'BR',
  },
  164730: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '100',
      counteract_share: '0',
      attitude: 'cooperate',
    },
    country_code: 'BR',
  },
  164733: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '100',
      counteract_share: '0',
      attitude: 'cooperate',
    },
    country_code: 'BR',
  },
  164678: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'FR',
  },
  164683: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '100',
      counteract_share: '0',
      attitude: 'cooperate',
    },
    country_code: 'MY',
  },
  164684: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'MY',
  },
  164698: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'BE',
  },
  164697: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'AR',
  },
  164672: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'IT',
  },
  164680: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'KZ',
  },
  164686: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'ZA',
  },
  164669: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'GB',
  },
  164673: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'ES',
  },
  164706: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'IR',
  },
  164675: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'PL',
  },
  164681: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'KZ',
  },
  164685: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'ZA',
  },
  164705: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'IR',
  },
  164659: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'RU',
  },
  164657: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'RU',
  },
  164658: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'RU',
  },
  164701: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'IR',
  },
  164660: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'IR',
  },
  164703: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'IR',
  },
  164702: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'IR',
  },
  164655: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'RU',
  },
  164700: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'IR',
  },
  164709: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'EG',
  },
  164699: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'IR',
  },
  164704: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '100',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'attack',
    },
    country_code: 'IR',
  },
  164708: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'EG',
  },
  164679: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'KZ',
  },
  164707: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'IR',
  },
  164674: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'PL',
  },
  164665: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '100',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'attack',
    },
    country_code: 'RU',
  },
  164656: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'RU',
  },
  164676: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'FR',
  },
  164667: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'DE',
  },
  164715: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'EU',
  },
  164670: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'IT',
  },
  164668: {
    attitude_balance: {
      negotiate_share: '100',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '0',
      attitude: 'negotiate',
    },
    country_code: 'DE',
  },
  164661: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'RU',
  },
  164671: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '100',
      counteract_share: '0',
      attitude: 'cooperate',
    },
    country_code: 'IT',
  },
  164736: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '100',
      counteract_share: '0',
      attitude: 'cooperate',
    },
    country_code: 'TR',
  },
  164718: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '0',
      counteract_share: '100',
      attitude: 'counteract',
    },
    country_code: 'EU',
  },
  164650: {
    attitude_balance: {
      negotiate_share: '0',
      attack_share: '0',
      cooperate_share: '100',
      counteract_share: '0',
      attitude: 'cooperate',
    },
    country_code: 'CN',
  },
};
